export const sanitizePath = (path: string) => {
  const decodedPath = decodeURIComponent(path);
  const pathWithoutHash = decodedPath.split('?')[0];
  const pathWithoutTrailingSlash = pathWithoutHash.replace(/\/$/, '');

  return pathWithoutTrailingSlash;
};
